import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axiosInstance from "../../axios-instance";
import {
  parseAccountSetupComplete,
  resolveAccountSetupBusinessId,
} from "../../utils/accountSetup";

const AccountSetupNotice = () => {
  const [showNotice, setShowNotice] = useState(false);

  useEffect(() => {
    const businessId = resolveAccountSetupBusinessId();
    if (!businessId) {
      return;
    }

    let cancelled = false;

    const loadStatus = () => {
      axiosInstance
        .get(`admin/account-setup-status/${businessId}`)
        .then((response) => {
          if (cancelled) return;
          setShowNotice(!parseAccountSetupComplete(response.data));
        })
        .catch(() => {
          if (!cancelled) {
            setShowNotice(true);
          }
        });
    };

    loadStatus();
    window.addEventListener("focus", loadStatus);

    return () => {
      cancelled = true;
      window.removeEventListener("focus", loadStatus);
    };
  }, []);

  if (!showNotice) {
    return null;
  }

  return (
    <div className="setup-notice" role="status">
      <div className="setup-notice__icon" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="1.6" />
          <path
            d="M10 6v4.25M10 13.75h.01"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      </div>
      <div className="setup-notice__body">
        <p className="setup-notice__title">Complete your account setup</p>
        <p className="setup-notice__text">
          Finish your business profile to share booking pages with clients.
        </p>
      </div>
      <Link to="/admin/quick-setup-step-one" className="setup-notice__action">
        Continue setup
      </Link>
    </div>
  );
};

export default AccountSetupNotice;
